import { HotSaleIcon } from '@/components/Icon/HotSaleIcon'
import { FlashSaleType } from '@/constants'
import { useMemo } from 'react'
export interface ProgressBarProps {
  flashSale: {
    quantity: number
    soldQuantity: number
    endTime: number
  }
  type?: string
  fsType?: FlashSaleType
}

const ProgressBarV1 = ({ flashSale, type, fsType }: ProgressBarProps) => {
  const leftItems = useMemo(() => {
    if (fsType === FlashSaleType.PROMOTION) {
      return 99
    }
    if (flashSale) {
      return (
        ((Number(flashSale.quantity) - Number(flashSale.soldQuantity)) /
          Number(flashSale.quantity)) *
        100
      )
    }
    return 0
  }, [flashSale])

  const renderProgressSeller = useMemo(() => {
    if (leftItems <= 0 && flashSale.soldQuantity > 0) {
      return (
        <div className='totalCount'>
          <i className='outStockIcon'></i>
          <p
            className={`${
              type == 'product-detail'
                ? 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-semibold mt-[2px] leading-[25px] text-dark-900'
                : 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-medium mt-[2px] leading-[22px] text-dark-900'
            } available absolute top-[50%]  translate-y-[-50%] text-mainBody text-dark-400 w-full`}
          >
            Đã bán hết
          </p>
        </div>
      )
    } else if (leftItems < 90 && leftItems > 0) {
      return (
        <div className='totalCount'>
          <p
            className={`${
              type == 'product-detail'
                ? 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-semibold mt-[2px] leading-[25px] text-dark-900'
                : 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-medium mt-[2px] leading-[22px] text-dark-900'
            } available absolute top-[50%]  translate-y-[-50%] text-mainBody text-dark-400 w-full`}
          >{` Còn ${flashSale.quantity - flashSale.soldQuantity}/${
            flashSale.quantity
          } suất`}</p>
        </div>
      )
    } else if (leftItems >= 90) {
      return (
        <div className='totalCount'>
          <p
            className={`${
              type == 'product-detail'
                ? 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-semibold mt-[2px] leading-[25px] text-dark-900'
                : 'left-[50%] translate-x-[-50%] text-center sm:text-[10px] md:text-[11px] font-medium mt-[2px] leading-[22px] text-dark-900'
            } available absolute top-[50%] translate-y-[-50%] text-mainBody text-dark-400`}
          >{`Vừa mở bán`}</p>
        </div>
      )
    }
  }, [flashSale])
  return (
    <div className={`${type == 'product-detail' ? ' mt-1.5' : 'pt-1'}`}>
      <div
        className={`${
          leftItems <= 0 && flashSale.soldQuantity > 0
            ? 'bg-gradient-to-r from-gray-200 to-gray-600'
            : ' bg-gray-700 dark:bg-gray-700'
        } ${
          type == 'product-detail' ? 'mt-[5px]' : ''
        } relative w-full rounded-full`}
      >
        <div
          className={`${leftItems <= 0 ? 'bg-gray-100' : 'bg-flashSale'} ${
            type == 'product-detail'
              ? ' mt-0 h-[25px] justify-center font-semibold'
              : 'mt-0 h-[22px] font-medium leading-none text-dark-400'
          } flex items-center  sm:text-[10px] md:text-[11px] rounded-full text-center`}
          style={{
            width: leftItems >= 90 ? '100%' : leftItems + '%',
          }}
        >
          {type != 'product-detail' && (
            <HotSaleIcon className={'absolute left-0 bottom-0 z-[1px]'} />
          )}
          {renderProgressSeller}
        </div>
      </div>
    </div>
  )
}

export default ProgressBarV1
